<template>
    <div class="business-content-main goods-details">
        <div class="bread-nav">
            <div class="flex">
                <div>您当前位置：</div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>汽配快搜</el-breadcrumb-item>
                    <el-breadcrumb-item>搜商品</el-breadcrumb-item>
                    <el-breadcrumb-item>商品详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div style="max-width: 1000px;margin: 0 auto">
            <div class="detail-top">
                <div class="detail-top-left">
                    <div class="image-ctn" v-if="goodsMsg.PictureVideoList && goodsMsg.PictureVideoList[0]">
                        <div v-if="goodsMsg.PictureVideoList[coverIndex].IsVideo" class="video-item">
                            <video :src="downloadUrl + goodsMsg.PictureVideoList[coverIndex].Url" controls></video>
                        </div>
                        <div v-else>
                            <img :src="downloadUrl + goodsMsg.PictureVideoList[coverIndex].Url" :onerror="defaultImg" v-if="goodsMsg.PictureVideoList[0]">
                        </div>
                    </div>
                    <div class="image-ctn" v-else>
                        <img :src="noImg">
                    </div>
                    <div class="img-main" v-if="goodsMsg.PictureVideoList">
                        <div class="go-left" @click="goLeft" v-if="goodsMsg.PictureVideoList.length > 4">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                        <div class="go-right" @click="goRight" v-if="goodsMsg.PictureVideoList.length > 4">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                        <div class="toggle-img-ctn" id="toggleImgCtn">
                            <div class="image-ctn" v-for="(item,index) in goodsMsg.PictureVideoList">
                                <img @mouseover="toggleCover(index)"
                                     v-if="item.IsVideo"
                                     src="../../../assets/images/video-icon.png"
                                     style="width: 50px;height: 50px"
                                >
                                <img @mouseover="toggleCover(index)"
                                     v-else
                                     :src="downloadUrl + item.Url"
                                     :onerror="defaultImg">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-top-right">
                    <div class="goods-name" :title="goodsMsg.Name">{{goodsMsg.Name}}</div>
                    <div class="goods-price">
                        <!--  价格  -->
                        <div class="goods-price-item">
                            <span class="tb-metatit">价格</span>
                            <div class="goods-money">
                                <span class="tm-yen">￥</span>{{goodsMsg.ShopPrice}}
                                <span class="original-price">{{goodsMsg.MarketPrice}}</span>
                            </div>
                        </div>
                        <!-- 优惠券 -->
                        <div class="goods-price-item">
                            <span class="tb-metatit">优惠券</span>
                            <div>
                            <span class="quan-item" v-for="item in couponList">
                                <s></s>
                                <b></b>
                                <span class="text" v-if="item.Type == 0" >代金券{{item.CValue}}元</span>
                                <span class="text" v-if="item.Type == 1" >付款打{{item.CValue}}折</span>
                                <span class="text" v-if="item.Type == 2" >满{{item.OrderAmountLower}}换{{item.CValue}}积分</span>
                                <span class="text" v-if="item.Type == 3" >满{{item.OrderAmountLower}}减{{item.CValue}}元</span>
                            </span>
                            </div>
                        </div>
                        <!--  赠品  -->
                        <div class="goods-price-item" v-if="GiftPromotion[0]">
                            <span class="tb-metatit">赠品</span>
                            <div>
                                <div class="gift-item" v-for="item in GiftPromotion">
                                    {{item.Name}}x{{item.Number}}
                                </div>
                            </div>
                        </div>
                        <!-- 促销 -->
                        <div class="goods-price-item" v-if="SinglePromotion || BuyGivePromotion || FullDiscountPromotion || ExchangeBuyPromotion">
                            <span class="tb-metatit">促销</span>
                            <div class="promotion-text">
                                <!-- 单品促销 -->
                                <div v-if="SinglePromotion">
                                    <div v-if="SinglePromotion.DiscountType == 0">
                                        <div class="promotion-item">
                                            <div class="promotion-type">折扣</div>
                                            <div class="promotion-dir">{{SinglePromotion.DiscountValue}}折</div>
                                        </div>
                                    </div>
                                    <div v-else-if="SinglePromotion.DiscountType == 1">
                                        <div class="promotion-item">
                                            <div class="promotion-type">直降</div>
                                            <div class="promotion-dir">{{SinglePromotion.DiscountValue}}元</div>
                                        </div>
                                    </div>
                                    <div v-else-if="SinglePromotion.DiscountType == 2">
                                        <div class="promotion-item">
                                            <div class="promotion-type">折后价</div>
                                            <div class="promotion-dir">{{SinglePromotion.DiscountValue}}元</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 买送 -->
                                <div v-if="BuyGivePromotion">
                                    <div class="promotion-item">
                                        <div class="promotion-type">买送</div>
                                        <div class="promotion-dir">买{{BuyGivePromotion.BuyCount}}送{{BuyGivePromotion.SendCount}}</div>
                                    </div>
                                </div>
                                <!-- 满减 -->
                                <div v-if="FullDiscountPromotion">
                                    <div class="promotion-item">
                                        <div class="promotion-type">满减</div>
                                        <div class="promotion-dir">
                                            满{{FullDiscountPromotion.LimitMoney1}}减{{FullDiscountPromotion.CutMoney1}}
                                            <span v-if="FullDiscountPromotion.LimitMoney2">
                                            满{{FullDiscountPromotion.LimitMoney2}}减{{FullDiscountPromotion.CutMoney2}}
                                        </span>
                                            <span v-if="FullDiscountPromotion.LimitMoney3">
                                            满{{FullDiscountPromotion.LimitMoney3}}减{{FullDiscountPromotion.CutMoney3}}
                                        </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 换购促销 -->
                                <div v-if="ExchangeBuyPromotion">
                                    <div class="promotion-item">
                                        <div class="promotion-type">换购</div>
                                        <div class="promotion-dir">
                                            满{{ExchangeBuyPromotion.LimitMoney}}加{{ExchangeBuyPromotion.AddMoney}}可换购
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--  选择商品型号  -->
                    <div class="choose-content">
                        <div class="choose-main">
                            <div class="attributes" v-for="(item,index) in SpecificationList">
                                <span class="attributes-title">{{item.AttrName}}</span>
                                <span v-for="(Attr,idx) in item.AttributeValueList"
                                      class="attributes-item"
                                      :class="{'active':Attr.checked}"
                                      @click="chooseAttr(index,idx)"
                                >
                                {{Attr.AttrValueName}}
                            </span>
                            </div>
                        </div>
                    </div>
                    <div class="goods-msg" style="padding-top: 100px">
                        <el-button type="primary"  class="buy-btn" @click="pushGoods()">推送</el-button>
                    </div>
                </div>
            </div>
            <div class="goods-dir">
                <div class="dir-tab">
                    <div class="tab-item" :class="{'tab-active':active==1}" @click="active=1">
                        商品详情
                    </div>
                    <div class="tab-item" :class="{'tab-active':active==2}" @click="active=2">
                        商品评论({{tableDataLength}})
                    </div>
                    <div class="tab-item" v-if="PackagePromotion[0]" :class="{'tab-active':active==3}" @click="active=3">
                        推荐套装
                    </div>
                </div>
                <div class="goods-introduction" v-show="active == 1">
                    <div v-html="goodsMsg.GDesc"></div>
                </div>
                <div class="practical-model" v-show="active == 2">
                    <div class='comment-item' v-for="item in commentList">
                        <div class="comment-user-msg">
                            <div class="user-header-left">
                                <div class="image-ctn user-header-ctn" style="width: 40px;height: 40px">
                                    <img class="user-header" :src="downloadUrl + item.AvatarUrl" v-if="item.AvatarUrl[0] == 'U'" :onerror="defaultImg">
                                    <img class="user-header" :src="item.AvatarUrl" v-else>
                                </div>
                                <div >
                                    <div class="name">{{item.NickName}}</div>
                                    <div class="star">
                                        <div class='star-item'
                                             v-for="(i,index) in star"
                                             @click="doStar(index)">
                                            <img src='../../../assets/images/star-active.png'
                                                 v-if="index <= item.CommentList[0].GoodsStar-1">
                                            <img src='../../../assets/images/star.png' v-else>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="flex-grow: 1;">
                            <div class="comments-item" v-for="(comment,index) in item.CommentList">
                                <div class="zuip" v-if="index != 0">{{comment.dateDifference}}天之后追评</div>
                                <div class="comment-text">
                                    {{comment.Message}}
                                </div>
                                <div class="comment-images-ctn">
                                    <div class="image-ctn" v-for="i in comment.PictureList" >
                                        <template  v-if="i.IsVideo">
                                            <video :src="i.Url" controls ></video>
                                        </template >
                                        <template  v-else>
                                            <img :src="i.Url" class="comment-images-item" mode="aspectFill" @click="previewImg($event)">
                                        </template >
                                    </div>

                                </div>
                                <div class="time" v-if="index == 0">
                                    {{item.CommentList[0].ReviewTime}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-data" v-if="!commentList[0]">—— 暂无评论 ——</div>
                    <div class="dialog-pagination-ctn">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="searchData.page"
                                :page-sizes="[10, 20, 30, 40, 50]"
                                :page-size="searchData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableDataLength">
                        </el-pagination>
                    </div>
                </div>
                <div v-show="active == 3">
                    <div style="padding: 20px">
                        <div class="suit-text" v-for="item in PackagePromotion">
                            <div class="suit-xxs">
                                <template  v-for="(i,idx) in item.DetailList">
                                    <div>
                                        <div class="image-ctn">
                                            <img :src="downloadUrl + i.ShowImg">
                                        </div>
                                        <div class="suit-name" :title="i.Name">{{i.Name}}</div>
                                    </div>
                                    <div v-if="idx < item.DetailList.length - 1" class="jai">+</div>
                                </template>
                            </div>
                            <div class="suit-money">
                                <div style="margin-right: 20px">=</div>
                                <div style="text-align: center">
                                    <div>￥{{item.PackageMoney}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
                title="推送"
                :visible.sync="dialogVisible"
                width="800px"
        >   <div class="dialog-content">
            <!-- 推送商品 -->
            <template>
                <push @closeDialog="closeDialog" ref="push" :goodMsg="choosedGood"></push>
            </template>
        </div>
        </el-dialog>
    </div>
</template>
<script>
    import push from '@/components/business/search/pushShopGoods.vue'
    export default {
        name: 'qpdetail',
        components: {
            push
        },
        data(){
            return {
                choosedGood:[],
                goodsType:'',
                dialogVisible:false,
                categoriesShow:false,
                showBigSrc: "", //显示大图路径
                showBigState: false, // 是否显示大图
                PackagePromotion:[],
                star:[1,1,1,1,1],
                commentList:[], // 评论列表
                chosenAttr:[],
                SpecificationList:[],
                SinglePromotion:[],
                BuyGivePromotion:[],
                FullDiscountPromotion:[],
                ExchangeBuyPromotion:[],
                GiftPromotion:[],
                coverIndex:0,
                couponList:[], // 优惠券列表
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
                noImg:this.$util.DEFAULT_IMAGE_square,
                downloadUrl:this.$util.QN_URL_BASE,
                active:1,
                GoodsId:'',
                formData:{
                    number:1,
                },
                searchData:{ // 获取评论所需参数
                    GoodsId:'',
                    Page:1,
                    Limit:10
                },
                tableDataLength:0,
                goodsMsg:{},
                permission:{}
            }
        },
        created(){
            this.GoodsId = this.$route.query.id
            this.GoodsTypeId = this.$route.query.id
            this.searchData.GoodsId = this.$route.query.id
            this.getGoodsDetail()
            this.getCouponList()
            this.getComment()
            this.$util.getPermission('搜索商城商品').then((res)=>{
                this.permission = res
            })
        },
        methods:{
            closeDialog(){
                this.dialogVisible = false
            },
            pushGoods(item){
                if (item){
                    this.choosedGood = item
                }
                if (this.$store.state.connectState != 2){
                    this.$message({
                        message: '请先连接到客服并接入客户',
                        type: 'warning'
                    });
                    return
                }
                this.dialogVisible = true
            },
            goLeft(){
                let ctn = document.getElementById('toggleImgCtn')
                if (ctn.offsetLeft < 0){
                    ctn.style.left = ctn.offsetLeft + 90 + 'px'
                }
            },
            goRight(){
                let ctn = document.getElementById('toggleImgCtn')
                if (ctn.offsetWidth + ctn.offsetLeft - 450 >= 0 ){
                    ctn.style.left = ctn.offsetLeft - 90 + 'px'
                }
            },
            previewImg(event){
                this.showBigSrc = event.target.currentSrc;
                this.showBigState = true;
            },
            // 询问配件
            askGoods(){
                if (this.$store.state.connectState != 2){
                    this.$util.warningMsg('请先连接到客服再进行询问')
                    return
                }
                this.$store.commit('updateAskGoods',this.goodsMsg)
                this.$util.successMsg('已向客服发送该商品')
            },
            // 获取评论
            getComment(){
                this.$util.axiosGet({
                    url:'/api/MallGoods/GetGoodsCommentList',
                    data:this.searchData,
                }).then((res)=>{
                    let responseData = res.data
                    this.tableDataLength = res.count
                    for (let i=0;i<responseData.length;i++){
                        for(let j=0;j<responseData[i].CommentList.length;j++){
                            if(responseData[i].CommentList[j-1]){
                                responseData[i].CommentList[j].dateDifference = this.$util.dateDifference(responseData[i].CommentList[j].ReviewTime,responseData[i].CommentList[0].ReviewTime)
                            }
                        }
                    }
                    this.commentList = responseData
                })
            },
            // 选择规格
            chooseAttr(index,idx){
                let arr2 = this.SpecificationList
                for(let s=0;s<arr2[index].AttributeValueList.length;s++){
                    arr2[index].AttributeValueList[s].checked = false
                }
                arr2[index].AttributeValueList[idx].checked = true
                let oldId = this.GoodsId
                this.chooseGoodId()
                if (oldId != this.GoodsTypeId){
                    this.GoodsId =  this.GoodsTypeId
                    this.searchData = {
                        GoodsId:this.GoodsTypeId,
                        Page:1,
                        Limit:10
                    }
                    this.getGoodsDetail()
                    this.getComment()
                }
            },
            // 选择商品id
            chooseGoodId(){
                if(this.SpecificationList[0]){
                    let GoodsTypeId = ''
                    let arr1 = this.goodsMsg.AllSpecificationGoodsList
                    let arr2 = this.SpecificationList
                    let gkArr = []
                    for(let i= 0;i< arr2.length;i++){
                        for(let s=0;s<arr2[i].AttributeValueList.length;s++){
                            if(arr2[i].AttributeValueList[s].checked){
                                gkArr.push(arr2[i].AttributeValueList[s].AttrValueName)
                            }
                        }
                    }
                    let gkStr = gkArr.sort().toString()
                    for(let m=0;m<arr1.length;m++){
                        if(arr1[m].SpecificationList.sort().toString() == gkStr){
                            GoodsTypeId =arr1[m].GoodsId
                        }
                    }
                    if (GoodsTypeId){
                        this.GoodsTypeId = GoodsTypeId
                        this.chosenAttr = gkStr
                        return true
                    }
                    else {
                        this.$util.warningMsg('请选择规格')
                        return false
                    }
                }
                else {
                    this.GoodsTypeId = this.GoodsId
                    return true
                }
            },
            // 获取优惠券列表
            getCouponList(){
                this.$util.axiosGet({
                    url:'/api/MallCoupon/GetCouponList',
                    data:{
                        GoodsId:this.GoodsId,
                        UserId:this.$util.getSessionStorage('userMsg').uid
                    },
                }).then((res)=>{
                    this.couponList = res.data // 优惠券
                })

            },
            // 跳转结算页
            gotoOrderInfo(){
                this.$router.push(`/business/shop/getOrderInfo?GoodsId=${this.GoodsId}&GoodsType=5&GoodsTypeId=${this.GoodsTypeId}&number=${this.formData.number}`)
            },
            toggleCover(index){
                this.coverIndex = index
            },
            // 套装加入购物车
            suitJoinCar(PmId){
                this.$util.suitJoinCar(PmId).then(()=>{
                    this.$refs.toolbar.getTableData()
                })
            },
            // 添加到购物车
            addToCar(){
                this.$util.goodsJoinCar(this.GoodsId).then(()=>{
                    this.$refs.toolbar.getTableData()
                })
            },
            back(){
                this.$router.push('/business/search/goodSearch')
            },
            // 数量改变触发
            handleChange(){

            },
            // 获取商品详情
            getGoodsDetail(){
                this.$util.axiosGet({
                    url:'/api/MallGoods/GetGoods',
                    data:{
                        GoodsId:this.GoodsId,
                    },
                }).then((res)=>{
                    this.goodsMsg = res.data
                    this.SinglePromotion = res.data.SinglePromotion
                    this.GiftPromotion = res.data.GiftPromotion
                    this.BuyGivePromotion = res.data.BuyGivePromotion
                    this.FullDiscountPromotion = res.data.FullDiscountPromotion
                    this.ExchangeBuyPromotion = res.data.ExchangeBuyPromotion
                    let _PackagePromotion = res.data.PackagePromotion
                    for(let i=0;i<_PackagePromotion.length;i++){
                        let _PackageMoney = 0;
                        for(let j=0;j<_PackagePromotion[i].DetailList.length;j++){
                            _PackageMoney +=  (_PackagePromotion[i].DetailList[j].ShopPrice - _PackagePromotion[i].DetailList[j].Discount) * _PackagePromotion[i].DetailList[j].Number
                        }
                        _PackagePromotion[i].PackageMoney = this.$util.num2Float(_PackageMoney)
                    }
                    this.PackagePromotion = _PackagePromotion
                    // 商品规格
                    let _SpecificationList = res.data.AllSpecificationList
                    let checkedAttr = res.data.SpecificationList
                    let checkedAttrArray = []
                    let checkedAttrString = ''
                    if (_SpecificationList){
                        for(let s=0;s<_SpecificationList.length;s++){
                            for (let n=0;n<_SpecificationList[s].AttributeValueList.length;n++){
                                for(let o=0;o<checkedAttr.length;o++){
                                    if(checkedAttr[o].AttrName == _SpecificationList[s].AttrName){
                                        if(checkedAttr[o].AttrValueName == _SpecificationList[s].AttributeValueList[n].AttrValueName){
                                            _SpecificationList[s].AttributeValueList[n].checked = true
                                            checkedAttrArray.push(checkedAttr[o].AttrValueName)
                                        }
                                        else {
                                            _SpecificationList[s].AttributeValueList[n].checked = false
                                        }
                                    }
                                }
                            }
                        }
                        checkedAttrString = checkedAttrArray.join(' ')
                        this.chosenAttr = checkedAttrString
                    }
                    this.SpecificationList = _SpecificationList
                })
            },
            handleSizeChange(val) {
                this.searchData.Limit = val
                this.getComment()
            },
            handleCurrentChange(val) {
                this.searchData.Page = val
                this.getComment()
            },
        }
    }
</script>
<style lang="less" scoped>
    .user-header-ctn {
        display: inline-block;
    }
    .video-item {
        background: black;
        height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
        video {
            max-width: 350px;
            max-height: 350px;
        }
    }
    .ask-serves {
        position: fixed;
        right: 5px;
        top: 355px;
        z-index: 100;
        width: 25px;
        height: 25px;
        cursor: pointer;
    }
    .suit-buy-btn {
        width: 100px;
        height: 30px;
        line-height: 30px;
        background: @theme2;
        text-align: center;
        color: white;
        margin-top: 10px;
        border-radius: 10px;
        cursor: pointer;
    }
    .jai {
        padding:28px 0 !important;
    }
    .image-ctn {
        display: flex;
        align-items: center;
        img {
            width: 100%;
        }
    }

    .suit-text {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        .image-ctn {
            margin: 0 !important;
            width: 75px;
            height: 75px;
            overflow: hidden;
            image {
                width: 100%;
            }
        }
    }
    .suit-price {
        color: red;
        font-size: @font-md;
    }
    .suit-xxs {
        min-width: 342px;
        display: flex;
        align-content: space-between;
        > div {
            margin: 0 10px;
        }
    }
    .suit-money {
        display: flex;
        align-items: center;
    }
    .suit-name {
        margin-top: 10px;
        width: 75px;
    }
    .comments-item {
        border-bottom: 1px dashed @border3Color;
        padding-bottom: 10px;
        .time {
            padding-top: 10px;
            color: @border1Color;
        }
    }
    .comment-text {

    }
    .zuip {
        color: orange;
    }
    .comment-images-ctn {
        display: flex;
        img {
            width: 100px;
            height: 100px;
        }
    }
    .user-header-left {
        width: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .name {
            text-align: center;
            width: 90px;
            font-size: 12px;
            text-overflow:ellipsis;
            overflow:hidden;
            white-space:nowrap;
        }
    }
    .star {
        display: flex;
        justify-content: center;
    }
    .star-item {
        img {
            width: 12px;
            height: 12px;
        }
    }
    .user-header {
        max-width: 40px;
        max-height: 40px;
    }
    .comment-item {
        position: relative;
        display: flex;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid @border3Color;
    }
    .active {
        border: 1px solid @theme !important;
    }
    .attributes {
        padding-top: 20px;
    }
    .attributes-title {
        display: inline-block;
        width: 75px;
        padding-left: 14px;
    }
    .attributes-item {
        display: inline-block;
        padding: 6px 10px;
        border: 1px solid @font4Color;
        margin-right: 10px;
        cursor: pointer;
        &:hover {
            border: 1px solid @theme;
        }
    }
    .promotion-item {
        display: flex;
        color: @font3Color;
        font-size: @font-xs;
        align-items: flex-start;
        margin-bottom: 10px;
        .promotion-type {
            font-size: 12px;
            flex-shrink: 0;
            width: 50px;
            height: 20px;
            line-height: 20px;
            border-radius: 20px;
            /*color: red;*/
            text-align: center;
            border: 1px solid red;
            margin-right: 20px;
        }
    }
    .goods-money {
        font-size: 28px;
        color: red;
    }
    .gift-item {
        display: flex;
        align-items: center;
        font-size: @font-xs;
        color: @font2Color;
        img {
            width: 27px;
            height: auto;
        }
    }
    .quan-item {
        position: relative;
        float: left;
        height: 16px;
        padding-left: 2px;
        line-height: 15px;
        text-align: center;
        border-top: 1px solid #df3033;
        border-bottom: 1px solid #df3033;
        background: #ffdedf;
        font-size: 14px;
        white-space: nowrap;
        margin-right: 13px;
        cursor: pointer;
        s,b {
            position: absolute;
            top: -1px;
            display: div;
            height: 16px;
            width: 2px;
            overflow: hidden;
            background: url('https://static.360buyimg.com/item/unite/1.0.81/components/default/prom/i/quan-arr.gif') no-repeat;
        }
        s {
            left: 0;
            background-position: -2px 0;
        }
        b {
            right: -2px;
        }
        .text {
            padding: 0 10px;
            color: #df3033;
            font-size: 12px;
        }
    }

    .goods-dir {
        width: 100%;
    }
    .goods-details {
        margin: 0 auto;
    }
    .bread-nav {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .back2 {
        position: absolute;
        right: 30px;
    }
    .practical-model {
        padding: 20px 0px;
        line-height: 1.5rem;
    }
    .goods-introduction {
        padding: 20px 0px;
        overflow-x:hidden;
    }
    .dir-tab {
        background: @border4Color;
        height: 48px;
        line-height: 48px;
        display: flex;
        border-bottom: 1px solid @theme;
        .tab-item {
            cursor: pointer;
            padding: 0 20px;
        }
    }
    .buy-btn {
        width: 150px;
    }
    .goods-msg {
        display: flex;
        align-items: center;
        height: 39px    ;
    }
    .tb-metatit {
        padding-top: 5px;
        color: #999;
        font-size: @font-xs;
        text-align: left;
        float: left;
        width: 75px;
        margin: 0 0 0 8px;
    }
    .tm-yen {
        color: #FF0036;
        font-size: 18px;
        font-family: Arial;
    }
    .goods-price {
        margin-top: 10px;
        background-color: @border3Color;
        padding: 10px;
        .goods-price-item {
            display: flex;
            align-items: flex-start;
            padding-bottom: 10px;
        }
    }
    .goods-name {
        font-size: 20px;
        font-weight: 700;
    }
    .detail-top-left {
        .image-ctn {
            border: 1px solid @border3Color;
            width: 350px;
            height: 350px;
            text-align: center;
            img {
                max-width: 350px;
                max-height: 350px;
            }
        }
    }
    .detail-top {
        display:flex;
        margin-bottom: 30px;
    }
    .detail-top-left {
        width: 350px;
        min-width: 410px;
        .img-main {
            margin-top: 30px;
            width: 350px;
            height: 80px;
            overflow: hidden;
            position: relative;
            overflow: hidden;
            .go-left {
                cursor: pointer;
                font-size: 26px;
                position: absolute;
                top: 30px;
                left: 0px;
                z-index: 1;
            }
            .go-right {
                cursor: pointer;
                font-size: 26px;
                position: absolute;
                top: 30px;
                right:0px;
                z-index: 1;
            }
        }
        .toggle-img-ctn {
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: flex-start;
            .image-ctn {
                cursor: pointer;
                margin-right: 10px;
                max-width: 80px;
                max-height: 80px;
                &:hover{
                    border: 3px solid @theme;
                }
            }
        }
    }
    .detail-top-right {
        flex-grow: 1;
    }
</style>
